/* BoldFlags® Theme v3 JS */

/* Mobile Drawer */
function openDrawer(){document.getElementById('mobile-drawer').classList.add('open');document.getElementById('drawer-overlay').classList.add('open');document.body.style.overflow='hidden';}
function closeDrawer(){document.getElementById('mobile-drawer').classList.remove('open');document.getElementById('drawer-overlay').classList.remove('open');document.body.style.overflow='';}

/* Quick Add to Cart */
function addToCart(e,id){
  e.preventDefault();e.stopPropagation();
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
  .then(function(r){return r.json();})
  .then(function(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=c.item_count;el.style.display=c.item_count>0?'flex':'none';});
    });
    var b=e.target.closest('.product-card-quick');
    if(b){b.textContent='✓ ADICIONADO';b.style.background='#2e7d46';setTimeout(function(){b.textContent='COMPRAR AGORA';b.style.background='';},1500);}
  });
}

/* Header scroll shadow */
window.addEventListener('scroll',function(){
  var h=document.getElementById('site-header');
  if(h){h.style.boxShadow=window.scrollY>50?'0 4px 24px rgba(0,0,0,.4)':'';}
});

const searchInput = document.querySelector('input[name="q"]');
if(searchInput){
  let box = document.createElement('div');
  box.style.cssText = 'position:absolute;background:#111;border:1px solid #222;width:100%;z-index:100;top:100%;left:0;';
  searchInput.parentElement.style.position='relative';
  searchInput.parentElement.appendChild(box);
  searchInput.addEventListener('input', async function(){
    const q = this.value.trim();
    if(q.length < 2){ box.innerHTML=''; return; }
    const res = await fetch(`/search/suggest.json?q=${q}&resources[type]=product&resources[limit]=6`);
    const data = await res.json();
    const products = data.resources.results.products;
    box.innerHTML = products.map(p => `
      <a href="${p.url}" style="display:flex;align-items:center;gap:12px;padding:10px 14px;border-bottom:1px solid #1a1a1a;text-decoration:none;color:#fff;">
        <img src="${p.image}" style="width:40px;height:40px;object-fit:cover;border-radius:3px;">
        <div>
          <div style="font-size:12px;font-weight:600;">${p.title}</div>
          <div style="font-size:11px;color:#f5c800;">${p.price}</div>
        </div>
      </a>`).join('') || '<p style="padding:12px;font-size:12px;color:#555;">Nenhum resultado</p>';
  });
  document.addEventListener('click', e => { if(!searchInput.contains(e.target)) box.innerHTML=''; });
}